import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from '../../component/auth/AuthContext';
import { login } from "../../store/session/action";
import { parseJwt, handleLogError } from '../../utils/Helpers';
import styles from './Login.module.scss';
import toggleOpen from '../../assets/image/toggle_open.png';
import toggleClosed from '../../assets/image/toggle_close.png';
import { usernamePattern } from '../../utils/convertUtil'
import GuestNaviBar from '../Guest/Navigator/GuestNaviBar';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const Auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameIsEmpty, setUsernameIsEmpty] = useState("");
  const [passwordIsEmpty, setPasswordIsEmpty] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (Auth.userIsAuthenticated()) {
      navigate("/home");
    }
  }, [Auth, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'username') {
      setUsername(value);
      if (!value) {
        setUsernameIsEmpty(t('auth.err.usernameEmpty'));
      } else if (!usernamePattern.test(value)) {
        setUsernameIsEmpty(t('auth.err.usernameInvalid'));
      } else {
        setUsernameIsEmpty("");
      }
      setError('');
    } else if (name === 'password') {
      setPassword(value);
      setPasswordIsEmpty(value ? '' : t('auth.err.passwordEmpty'));
      setError('');
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username) {
      setUsernameIsEmpty(t('auth.err.usernameEmpty'));
    }
    if (!password) {
      setPasswordIsEmpty(t('auth.err.passwordEmpty'));
    }

    if (!username || !password) {
      return;
    }

    try {
      const response = await login({ username, password });
      // console.log("login response["+JSON.stringify(response)+"]");

      if (response && response.token) {
        const accessToken = response.token;
        const data = parseJwt(accessToken);
        const authenticatedUser = { data, accessToken };

        Auth.userLogin(authenticatedUser);

        setUsername('');
        setPassword('');
        setError(null);
        setUsernameIsEmpty("");
        setPasswordIsEmpty("");
        navigate('/home');
      } else {
        setError(t('auth.err.loginFailed'));
      }
    } catch (error) {
      console.error("Login error: ", error);
      setError(t('auth.err.loginError'));
      handleLogError(error);
    }
  };

  return (
    <>
      <GuestNaviBar />
      <div className={styles.loginContainer}>
        <div className={styles.loginBox}>
          <h2 className={styles.loginTitle}>{t('auth.login.title')}</h2>
          <form onSubmit={handleSubmit}>
            <div className={styles.inputContainer}>
              <input
                type="text"
                placeholder={t('auth.field.username')}
                name="username"
                value={username || ""}
                onChange={handleInputChange}
                className={styles.noeye_inputField}
              />
            </div>
            {usernameIsEmpty && (
              <p className={styles.loginErrorMessage}>{usernameIsEmpty}</p>
            )}
            <div className={styles.passwordInputContainer}>
              <input
                type={showCurrentPassword ? 'text' : 'password'}
                placeholder={t('auth.field.password')}
                name="password"
                value={password || ""}
                onChange={handleInputChange}
                className={styles.inputField}
              />
              <img
                src={showCurrentPassword ? toggleOpen : toggleClosed}
                alt={t('auth.alt.togglePassword')}
                className={styles.togglePassword}
                onClick={togglePasswordVisibility}
              />
            </div>
            {passwordIsEmpty && (
              <p className={styles.loginErrorMessage}>{passwordIsEmpty}</p>
            )}
            <p className={styles.findText}>
              <Link to="/findpassword" className={styles.findLink}>{t('auth.login.forgotPassword')}</Link>
            </p>
            <button type="submit" className={styles.loginButton}>{t('auth.login.button')}</button>
          </form>
          {error && <p className={styles.loginErrorMessage}>{error}</p>}
          <p className={styles.signUpText}>
            {t('auth.login.noAccount')}{' '}
            <Link to="/signup" className={styles.signUpLink}>{t('auth.login.signup')}</Link>
          </p>
          <p className={styles.findText}>
            <Link to="/findusername" className={styles.findLink}>{t('auth.login.forgotUsername')}</Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
